"use client"
import { CssBaseline } from "@mui/material"
import { AppRouterCacheProvider } from "@mui/material-nextjs/v14-appRouter"
import {
  ThemeProvider as MuiThemeProvider,
  createTheme,
} from "@mui/material/styles"
import React from "react"
import rtlPlugin from "stylis-plugin-rtl"
import { theme } from "./theme"

export const ltrTheme = createTheme({ ...theme, direction: "ltr" })
export const rtlTheme = createTheme({ ...theme, direction: "rtl" })

const ThemeProviders = ({
  children,
  locale = "he",
}: {
  children: React.ReactNode
  locale: string
}) => {
  const [isRtl, setIsRtl] = React.useState(
    locale === "he" || locale === "ar" ? true : false,
  )

  React.useLayoutEffect(() => {
    document?.body.setAttribute("dir", isRtl ? "rtl" : "ltr")
  }, [isRtl])
  React.useLayoutEffect(() => {
    setIsRtl(locale === "he" || locale === "ar" ? true : false)
  }, [locale])

  const options = {
    key: isRtl ? "muirtl" : "muiltr",
    stylisPlugins: isRtl ? [rtlPlugin] : undefined,
  }

  return (
    <AppRouterCacheProvider options={options}>
      <MuiThemeProvider theme={isRtl ? rtlTheme : ltrTheme}>
        <CssBaseline />
        {children}
      </MuiThemeProvider>
    </AppRouterCacheProvider>
  )
}

export default ThemeProviders
